import {registration} from 'backend/auth';
import {local} from 'wix-storage';
import wixLocation from 'wix-location';
import {caseInfo} from 'backend/auth';


$w.onReady(function () {
	let name = JSON.parse(local.getItem("user")).Name;
	if (name) {
		$w('#helloName').text += name;
	}

	console.log(local.getItem('user'));
});


export function submit_click(event) {
	let text = $w('#caseText').value; 
	let userID = JSON.parse(local.getItem("user")).ID;
	console.log(userID);
	
	if (userID && text) {
		if ( !($w('#error').collapsed) ) {
			$w('#error').collapse();
		}

		$w('#submit').collapse();
		$w('#loading').expand();	

	 	caseInfo(text, userID).then(response => {
			if (response.error) {
				throw new Error(response.error.message);
			}
		
		wixLocation.to('/lp-home2');
		}).catch(error => {
				$w('#submit').expand();
				$w('#loading').collapse();
			switch (error.message) {
				case 'TEXT_ALREADY_EXISTS':
						$w('#error').text = 'Вече сте добавили вашия случай!'
						$w('#error').expand();
					break;
				default:
					break;
			}
		})
	}else {
		if (!userID) {
			$w('#error').text = 'Моля влезте в профила си преди да изпратите формата!'
		} else {
		    $w('#error').text = 'Попълнете формата преди да я изпратите!'
		}
		 $w('#error').expand();
	}
}
